<template>
  <div class="mobile-footer">
    <div
      class="fixed bottom-0 left-0 z-50 w-full h-16 bg-white border-t border-gray-200 dark:bg-gray-700 dark:border-gray-600 transition-transform duration-300"
      :class="[
        isScrollingDown ? 'translate-y-full' : 'translate-y-0',
        'sm:hidden'
      ]"
    >
      <div class="grid h-full max-w-lg grid-cols-5 mx-auto font-medium">
        <nuxt-link
          v-for="item in navigationItems"
          :key="item.to"
          :to="item.to"
          class="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
        >
          <Icon
            :name="item.icon"
            class="w-6 h-6 mb-2 text-gray-500 dark:text-gray-400 group-hover:text-black dark:group-hover:text-gray-600"
          />
          <span
            class="text-sm text-gray-500 dark:text-gray-400 group-hover:text-black dark:group-hover:text-gray-600"
          >{{ item.text }}</span>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { isScrollingDown } = useScrollDirection()

const navigationItems = [
  {
    text: 'Home',
    to: '/',
    icon: 'heroicons:home'
  },
  {
    text: 'Events',
    to: '/events',
    icon: 'heroicons:bell-alert'
  },
  {
    text: 'People',
    to: '/people',
    icon: 'heroicons:users'
  },
  {
    text: 'Buzz',
    to: '/buzz',
    icon: 'heroicons:pencil-square'
  },
  {
    text: 'Add',
    to: '/add',
    icon: 'heroicons:plus-circle'
  }
]
</script>